import React, {FunctionComponent, useMemo} from 'react';
import {FormGroup} from '@blueprintjs/core';
import debounce from "lodash/debounce";

import {IItem, SimpleSelect} from '../../select';
import {Loading} from '../components';

interface SelectTableauEmbedItemProps {
  label: string;
  selected: string;
  disabled: boolean;
  onChange: (value: any) => void;
  options: IItem[] | undefined | null;
  onFilter: (value: any) => void;
  loading: boolean;
  showLoadingIcon?: boolean;
  // we use selectDefault property to prevent the select from selecting the first item (used for Custom Views)
  selectDefault?: boolean;
  // we use unselectDefault property to allow the select to be unselected (used for Custom Views)
  unselectDefault?: boolean;
  onClick?: () => void;
}

const SelectTableauEmbedItem: FunctionComponent<SelectTableauEmbedItemProps> = ({
  label,
  selected,
  disabled,
  onChange,
  options,
  onFilter,
  loading,
  showLoadingIcon = false,
  selectDefault = true,
  unselectDefault = false,
  onClick = undefined,
}: SelectTableauEmbedItemProps) => {
  const debounceOnFilter = useMemo(() => debounce(onFilter, 800), [onFilter]);

  return (
    <FormGroup label={label} inline={true}>
      <SimpleSelect
        selected={selected}
        disabled={disabled || loading}
        onChange={onChange}
        selectDefault={selectDefault}
        unselectDefault={unselectDefault}
        options={options || []}
        onQueryChange={debounceOnFilter} // enable filtering so we can create new elements from queries
        label="No option selected"
        buttonProps={{
          minimal: true,
          small: true,
          outlined: true,
          onClick: onClick,
        }}
        popoverProps={{
          usePortal: true
        }}
        inputProps={{
          rightElement: showLoadingIcon ? <Loading/> : undefined,
        }}
      />
    </FormGroup>
  );
};

export default SelectTableauEmbedItem;
